export default {
  description:
    'PennyLane is a cross-platform Python library for quantum computing, quantum machine learning, and quantum chemistry. Built by researchers, for research. Created with ❤️ by [Xanadu](https://xanadu.ai/).',
  footerTopTagline: {
    text: 'Stay updated with our newsletter',
    href: 'https://xanadu.us17.list-manage.com/subscribe?u=725f07a1d1a4337416c3129fd&id=294b062630',
  },
  footerSocials: [
    {
      icon: 'bxl-linkedin',
      href: 'https://www.linkedin.com/company/pennylaneai/',
      ariaLabel: 'linkedin',
    },
    {
      icon: 'bxl-github',
      href: 'https://github.com/PennyLaneAI/pennylane',
      ariaLabel: 'github',
    },
    {
      icon: 'bxl-youtube',
      href: 'https://www.youtube.com/@pennylaneai/',
      ariaLabel: 'youtube',
    },
    {
      icon: 'bxl bx-twitter-x',
      href: 'https://twitter.com/PennyLaneAI',
      ariaLabel: 'twitter',
    },
    {
      icon: 'bxl-discord',
      href: 'https://discord.com/invite/gnySM3nrN3',
      ariaLabel: 'discord',
    },
    {
      icon: 'bxl-slack',
      href: 'https://join.slack.com/t/xanadu-quantum/shared_invite/zt-1i8v8v49d-S76QxXm3OKCm9g0bvWvDpg',
      ariaLabel: 'slack',
    },
    {
      icon: 'bxl-discourse',
      href: 'https://discuss.pennylane.ai',
      ariaLabel: 'discourse',
    },
  ],
  footerLinks: [
    {
      title: 'Research',
      links: [
        {
          name: 'Research',
          href: '/research',
        },
        {
          name: 'Performance',
          href: '/performance',
        },
        {
          name: 'Hardware & Simulators',
          href: '/devices',
        },
        {
          name: 'Demos',
          href: '/qml/demonstrations',
        },
        {
          name: 'Quantum Compilation',
          href: '/compilation',
        },
        {
          name: 'Quantum Datasets',
          href: '/datasets',
        },
      ],
    },
    {
      title: 'Education',
      links: [
        {
          name: 'Teach',
          href: '/education',
        },
        {
          name: 'Learn',
          href: '/qml',
        },
        {
          name: 'Codebook',
          href: '/codebook',
        },
        {
          name: 'Coding Challenges',
          href: '/challenges',
        },
        {
          name: 'Videos',
          href: '/qml/videos',
        },
        {
          name: 'Glossary',
          href: '/qml/glossary',
        },
      ],
    },
    {
      title: 'Software',
      links: [
        {
          name: 'Install PennyLane',
          href: '/install',
        },
        {
          name: 'Features',
          href: '/features',
        },
        {
          name: 'Documentation',
          href: 'https://docs.pennylane.ai',
        },
        {
          name: 'Catalyst Compilation Docs',
          href: 'https://docs.pennylane.ai/projects/catalyst/en/stable/',
        },
        {
          name: 'Development Guide',
          href: 'https://docs.pennylane.ai/en/stable/development/guide.html',
        },
        {
          name: 'API',
          href: 'https://docs.pennylane.ai/en/stable/code/qml.html',
        },
        {
          name: 'GitHub',
          href: 'https://github.com/PennyLaneAI/pennylane',
          external: true,
        },
      ],
    },
  ],
  footerPolicies: [
    {
      text: 'Privacy Policy',
      href: '/privacy',
    },
    {
      text: 'Terms of Service',
      href: '/terms',
    },
    {
      text: 'Cookie Policy',
      href: '/cookies',
    },
    {
      text: 'Code of Conduct',
      href: '/conduct',
    },
  ],
}
